module.exports = __webpack_public_path__ + "img/christophers-screenshot.978875a0.png";